export default {
  name: "AppDetailTab3",
  data() {
    return {};
  }
};